import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-flush h-xl-100" }
const _hoisted_2 = { class: "card-header pt-7" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder text-dark" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  style: {"margin-right":"5px","margin-left":"5px"},
  class: "form-check form-switch form-check-custom form-check-solid"
}
const _hoisted_7 = { class: "form-check-label fw-bold text-muted" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1)
const _hoisted_9 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_10 = { class: "form-check-label fw-bold text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-unlock" }, null, -1)
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_14 = { class: "hover-scroll-overlay-y pe-6 me-n6 course-h-200" }
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = ["onChange", "id"]
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  class: "card card-flush py-3 flex-row-fluid",
  style: {"background-color":"transparent"}
}
const _hoisted_19 = { class: "text-gray-600" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-2x me-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 7C10.3 7 9 8.3 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 8.3 13.7 7 12 7Z",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 22C14.6 22 17 21 18.7 19.4C17.9 16.9 15.2 15 12 15C8.8 15 6.09999 16.9 5.29999 19.4C6.99999 21 9.4 22 12 22Z",
      fill: "black"
    })
  ])
], -1)
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_24 = { class: "fw-bold text-gray-400 text-start fs-7" }
const _hoisted_25 = {
  key: 1,
  class: "d-flex flex-wrap"
}
const _hoisted_26 = { class: "border border-gray-500 border-dashed rounded py-2 px-2 me-2 mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-800 fw-bolder" }, "-")
], -1)
const _hoisted_28 = { class: "fw-bold text-gray-400 text-start fs-7" }
const _hoisted_29 = { class: "m-0" }
const _hoisted_30 = {
  key: 0,
  class: "d-print-none border border-dashed border-gray-300 card-rounded h-lg-100 min-w-md-350px p-9 pe-4 pb-0 bg-lighten"
}
const _hoisted_31 = {
  class: "hover-scroll-overlay-y",
  style: {"height":"529px"}
}
const _hoisted_32 = { class: "mb-8 fw-boldest text-gray-600 text-hover-primary" }
const _hoisted_33 = { class: "mb-6" }
const _hoisted_34 = { class: "fw-bold text-gray-600 fs-7" }
const _hoisted_35 = { class: "fw-bolder text-gray-800 fs-6" }
const _hoisted_36 = { class: "mb-6" }
const _hoisted_37 = { class: "fw-bold text-gray-600" }
const _hoisted_38 = {
  key: 0,
  class: "fw-bolder text-gray-800 fs-6"
}
const _hoisted_39 = {
  key: 1,
  class: "fw-bolder text-danger fs-6"
}
const _hoisted_40 = { class: "mb-6" }
const _hoisted_41 = { class: "fw-bold text-gray-600" }
const _hoisted_42 = { class: "fw-bolder text-danger fs-6" }
const _hoisted_43 = { class: "mb-6" }
const _hoisted_44 = { class: "fw-bold text-gray-600" }
const _hoisted_45 = { class: "fw-bolder fs-6" }
const _hoisted_46 = { class: "mb-6" }
const _hoisted_47 = { class: "fw-bold text-gray-600" }
const _hoisted_48 = { class: "fw-bolder text-gray-800 fs-6" }
const _hoisted_49 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_50 = { class: "fw-bold fs-6 text-gray-800 fw-bolder" }
const _hoisted_51 = { class: "d-flex align-items-center text-gray-400 text-start fs-7" }
const _hoisted_52 = { class: "" }
const _hoisted_53 = { class: "mb-6" }
const _hoisted_54 = { class: "fw-bold text-gray-600" }
const _hoisted_55 = { class: "fw-bolder text-gray-800 fs-6" }
const _hoisted_56 = { class: "mb-6" }
const _hoisted_57 = { class: "fw-bold text-gray-600 fs-7" }
const _hoisted_58 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_59 = {
  key: 0,
  class: "fw-boldest gray-600"
}
const _hoisted_60 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_61 = {
  key: 0,
  class: "fw-boldest gray-600"
}
const _hoisted_62 = { class: "mb-6" }
const _hoisted_63 = { class: "fw-bold text-gray-600" }
const _hoisted_64 = { class: "fw-bolder text-danger fs-6" }
const _hoisted_65 = { class: "mb-6" }
const _hoisted_66 = { class: "fw-bold text-gray-600" }
const _hoisted_67 = { class: "fw-bolder text-danger fs-6" }
const _hoisted_68 = {
  key: 2,
  class: "fw-boldest gray-600"
}
const _hoisted_69 = {
  key: 3,
  class: "mb-6"
}
const _hoisted_70 = {
  key: 4,
  class: "fw-boldest gray-600"
}
const _hoisted_71 = {
  key: 5,
  class: "mb-6"
}
const _hoisted_72 = {
  key: 0,
  class: "pb-5"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-5 pt-0" }, null, -1)
const _hoisted_74 = { key: 1 }
const _hoisted_75 = {
  key: 0,
  class: "pb-5"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-5 pt-0" }, null, -1)
const _hoisted_77 = {
  key: 1,
  class: "pb-5"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-5 pt-0" }, null, -1)
const _hoisted_79 = {
  key: 1,
  class: "d-print-none border border-dashed border-gray-300 card-rounded h-lg-100 min-w-md-350px p-9 pe-4 pb-0 bg-lighten"
}
const _hoisted_80 = {
  class: "hover-scroll-overlay-y",
  style: {"height":"529px"}
}
const _hoisted_81 = { class: "mb-8 fw-boldest text-gray-600 text-hover-primary" }
const _hoisted_82 = { class: "mb-12" }
const _hoisted_83 = { class: "fw-bold text-gray-600 fs-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate("offeredCourses.sections")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.noclash && _ctx.noclash(...args))),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isClash) = $event)),
            class: "form-check-input",
            type: "checkbox"
          }, null, 544), [
            [_vModelCheckbox, _ctx.isClash]
          ]),
          _createElementVNode("span", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.translate("offeredCourses.noClash")), 1)
          ])
        ]),
        _createElementVNode("label", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.notFull && _ctx.notFull(...args))),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isFull) = $event)),
            class: "form-check-input",
            type: "checkbox"
          }, null, 544), [
            [_vModelCheckbox, _ctx.isFull]
          ]),
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.translate("offeredCourses.notFull")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass([
            _ctx.currentLanguage == 'ar' ? 'ms-xl-0' : '',
            'flex-lg-row-fluid me-xl-10 mb-10 mb-xl-0',
          ])
        }, [
          _createElementVNode("div", _hoisted_14, [
            (_ctx.filteredSections && _ctx.filteredSections.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSections, (section) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-md-12",
                      key: section.sC_SCHEDULE_DTL_ID
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        onChange: ($event: any) => (
                    _ctx.loadSectionDetails(_ctx.CourseId, section.sC_SCHEDULE_DTL_ID)
                  ),
                        type: "radio",
                        class: "btn-check",
                        name: "sections",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedSection) = $event)),
                        value: 0,
                        id: 'kt_section_2' + section.sC_SCHEDULE_DTL_ID
                      }, null, 40, _hoisted_16), [
                        [_vModelRadio, _ctx.selectedSection]
                      ]),
                      _createElementVNode("label", {
                        class: "btn btn-outline btn-outline-dashed btn-outline-default p-0 d-flex align-items-center mb-2 bg-white",
                        for: 'kt_section_2' + section.sC_SCHEDULE_DTL_ID
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["card-body pt-0 pb-0 ps-3 pe-3 text-start", section.isClashed == true ? 'conflict' : ''])
                          }, [
                            _createElementVNode("h4", {
                              class: _normalizeClass(
                          section.isClashed == true
                            ? 'text-danger'
                            : 'text-gray-600'
                        )
                            }, _toDisplayString(_ctx.translate("offeredCourses.sectionNo")) + " " + _toDisplayString(section.groupDescr), 3),
                            _createElementVNode("h6", _hoisted_19, [
                              _hoisted_20,
                              _createTextVNode(_toDisplayString(section.staffs.stfFullName), 1)
                            ]),
                            (section.scScheduleDays)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.scScheduleDays, (day) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: day.hallId,
                                      class: "border border-gray-500 border-dashed rounded py-2 px-2 me-2 mb-2"
                                    }, [
                                      _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formattedDate(day.fromTime) || "") + " - " + _toDisplayString(_ctx.formattedDate(day.toTime) || ""), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_24, _toDisplayString(day.gsCodeWeekDayDescr), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, [
                                    _hoisted_27,
                                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.translate("noContent")), 1)
                                  ])
                                ]))
                          ], 2)
                        ])
                      ], 8, _hoisted_17)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_29, [
          (
              _ctx.Sectionetails.length > 0 &&
              _ctx.sectionDetailsRes.sectionDetail &&
              _ctx.sectionDetailsRes.sectionDetail[0]
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("h6", _hoisted_32, _toDisplayString(_ctx.translate("offeredCourses.sctionDetails")), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.translate("offeredCourses.sectionNo")) + ": ", 1),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.sectionDetailsRes.sectionDetail[0].groupDescr), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.translate("offeredCourses.availSeats")) + ": ", 1),
                    (_ctx.sectionDetailsRes.sectionDetail[0].availableSeats > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.sectionDetailsRes.sectionDetail[0].availableSeats), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.translate("offeredCourses.sectionFull")), 1))
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.translate("offeredCourses.studyLang")) + ": ", 1),
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.sectionDetailsRes.sectionDetail[0].gsCodeLanguageDescr), 1)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.translate("gender")) + ": ", 1),
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.sectionDetailsRes.sectionDetail[0].gsCodeGenderId == 0
                      ? _ctx.translate("mixed")
                      : _ctx.sectionDetailsRes.sectionDetail[0].gsCodeGenderDescr), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.translate("offeredCourses.examTime")) + ": ", 1),
                    _createElementVNode("div", _hoisted_48, [
                      (_ctx.sectionDetailsRes.sectionDetail[0].exams)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionDetailsRes.sectionDetail[0].exams, (exam) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: exam.hallId,
                                class: "border border-gray-500 border-dashed rounded py-2 px-2 me-2 mb-2"
                              }, [
                                _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.formattedDateTime(exam.examTime)), 1),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.formattedDate(exam.fromTime)) + " - " + _toDisplayString(_ctx.formattedDate(exam.toTime)), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.translate("offeredCourses.examNoperDay")) + ": ", 1),
                    _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.sectionDetailsRes.sectionDetail[0].examsInSameDay), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.translate("offeredCourses.rooms")) + ": ", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueScheduleDays, (scheduleDay, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "fw-bolder text-gray-800 fs-6",
                        key: index
                      }, _toDisplayString(scheduleDay.campCode) + " / " + _toDisplayString(scheduleDay.scBuildingDescr) + " / " + _toDisplayString(scheduleDay.scHallDescr), 1))
                    }), 128))
                  ]),
                  (
                  _ctx.sectionDetailsRes.sectionDetail[0].sectionConflictCount > 0
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        (
                    _ctx.sectionDetailsRes.sectionDetail[0].sectionConflictCount > 0
                  )
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_59, _toDisplayString(_ctx.translate("offeredCourses.schConfilicts")), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionDetailsRes.sectionDetail[0]
                    .sectionConflict, (conflict, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'conflict' + index,
                            class: "fw-bolder fs-6 text-danger"
                          }, _toDisplayString(conflict.edCourseCode) + " ", 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.sectionDetailsRes.sectionDetail[0].siteConflictCount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        (
                    _ctx.sectionDetailsRes.sectionDetail[0].siteConflictCount > 0
                  )
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_61, _toDisplayString(_ctx.translate("offeredCourses.siteConflict")), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionDetailsRes.sectionDetail[0]
                    .siteConflict, (conflict, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'conflict' + index,
                            class: "fw-bolder fs-6 text-danger"
                          }, _toDisplayString(conflict.edCourseCode) + " ", 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.translate("offeredCourses.techingPeriodDescr")) + ": ", 1),
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.sectionDetailsRes.sectionDetail[0]?.techingPeriodDescr.trim() ||
                    "--"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.translate("offeredCourses.remarks")) + ": ", 1),
                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.sectionDetailsRes.sectionDetail[0]?.notes || "--"), 1)
                  ]),
                  (_ctx.sectionDetailsRes.sectionDetail[0].examConflictCount > 0)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_68, _toDisplayString(_ctx.translate("offeredCourses.examConflict")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.sectionDetailsRes.sectionDetail[0].examConflictCount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionDetailsRes.sectionDetail[0]
                    .examConflict, (conflict, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fw-bolder fs-6 text-danger",
                            key: index
                          }, _toDisplayString(conflict.edCourseCode) + " ", 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.sectionDetailsRes.sectionDetail[0].lapConflictCount > 0)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_70, _toDisplayString(_ctx.translate("offeredCourses.lapConflict")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.sectionDetailsRes.sectionDetail[0].lapConflictCount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionDetailsRes.sectionDetail[0]
                    .lapConflict, (conflict, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fw-bolder fs-6 text-danger",
                            key: index
                          }, _toDisplayString(conflict.edCourseCode) + " ", 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.edStudCourseRegId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _hoisted_73,
                      (
                  _ctx.isReplace == true &&
                  _ctx.sectionDetailsRes.sectionDetail[0].validReplace == true
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (
                  _ctx.replace(
                    _ctx.edStudCourseRegId,
                    _ctx.sectionDetailsRes.sectionDetail[0].scheduleDtlId,
                    _ctx.sectionDetailsRes.edStudSemesterId,
                    _ctx.CourseId,
                    _ctx.EnT_COURSE_PKG_DTL_ID
                  )
                )),
                            class: "btn btn-primary"
                          }, _toDisplayString(_ctx.translate("regisCourses.replaceCourse")), 1))
                        : _createCommentVNode("", true),
                      (
                  _ctx.isReplace &&
                  _ctx.sectionDetailsRes.sectionDetail[0].validReplace == false &&
                  _ctx.sectionDetailsRes.sectionDetail[0].addSeatVisible == true
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (
                  _ctx.addSeatReplace(
                    _ctx.edStudCourseRegId,
                    _ctx.sectionDetailsRes.sectionDetail[0].scheduleDtlId,
                    _ctx.sectionDetailsRes.edStudSemesterId,
                    _ctx.CourseId,
                    _ctx.EnT_COURSE_PKG_DTL_ID
                  )
                )),
                            class: "btn btn-primary"
                          }, _toDisplayString(_ctx.translate("offeredCourses.addSeat")), 1))
                        : _createCommentVNode("", true),
                      (
                  _ctx.isReplace == false &&
                  _ctx.sectionDetailsRes.sectionDetail[0].validReg == true
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (
                  _ctx.undrop(
                    _ctx.edStudCourseRegId,
                    _ctx.sectionDetailsRes.sectionDetail[0].scheduleDtlId
                  )
                )),
                            class: "btn btn-primary"
                          }, _toDisplayString(_ctx.translate("regisCourses.unDropCourse")), 1))
                        : _createCommentVNode("", true),
                      (
                  _ctx.isReplace == false &&
                  _ctx.sectionDetailsRes.sectionDetail[0].addSeatVisible == true
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addSeat(_ctx.CourseId, _ctx.EnT_COURSE_PKG_DTL_ID))),
                            class: "btn btn-primary"
                          }, _toDisplayString(_ctx.translate("offeredCourses.addSeat")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      (_ctx.sectionDetailsRes.sectionDetail[0].addSeatVisible == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _hoisted_76,
                            _createElementVNode("button", {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addSeat(_ctx.CourseId, _ctx.EnT_COURSE_PKG_DTL_ID))),
                              class: "btn btn-primary"
                            }, _toDisplayString(_ctx.translate("offeredCourses.addSeat")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.sectionDetailsRes.sectionDetail[0].validReg == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _hoisted_78,
                            _createElementVNode("button", {
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.register(_ctx.CourseId, _ctx.EnT_COURSE_PKG_DTL_ID))),
                              class: "btn btn-primary"
                            }, _toDisplayString(_ctx.translate("offeredCourses.regisCourse")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("h6", _hoisted_81, _toDisplayString(_ctx.translate("offeredCourses.sctionDetails")), 1),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.translate("offeredCourses.noSelect")), 1)
                  ])
                ])
              ]))
        ])
      ])
    ])
  ]))
}